<template>
    <div class="booking-slide">
        <transition name="slide" mode="out-in">
            <ServiceType v-if="step == 0" :ui="ui" :service-type="serviceType" @submit="next" />

            <component
                :is="'Questions' + serviceType"
                v-if="step == 1"
                :ui="ui"
                :service-type="serviceType"
                :service-questions="serviceQuestions"
                :is-loading="isLoading"
                @submit="next"
                @back="back"
            />
        </transition>
    </div>
</template>

<script>
import { trackType } from '@/../vue/online-booking/utils/tracking';
import scrollTop from '@/../vue/online-booking/utils/scroll';
import ServiceType from '@/../vue/online-booking/steps/service/ServiceType.vue';
import QuestionsOptical from '@/../vue/online-booking/steps/service/QuestionsOptical.vue';
import QuestionsDental from '@/../vue/online-booking/steps/service/QuestionsDental.vue';

export default {
    components: {
        ServiceType,
        QuestionsOptical,
        QuestionsDental
    },

    props: {
        serviceQuestions: {
            type: Object,
            required: true
        },
        serviceType: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        },
        ui: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        step: 1
    }),

    methods: {
        next(payload) {
            this.$emit('submit-data', payload);
            if (this.step == 1) {
                this.$modal.show('serviceStepComplete' + this.serviceType, {
                    onAcceptAndClose: this.acceptAndClose
                });
            } else {
                this.step++;
                trackType(payload.serviceType);
                scrollTop();
            }
        },
        acceptAndClose() {
            this.$modal.hide('serviceStepComplete' + this.serviceType);
            this.$emit('complete');
        },
        back() {
            this.step--;
        }
    }
};
</script>
